import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_ALLOWANCES,
  CREATE_ALLOWANCE_REQUEST,
  DELETE_ALLOWANCE,
} from "./actionTypes";
import {
  fetchAllowances,
  fetchAllowancesSuccess,
  fetchAllowancesFailure,
  createAllowanceSuccess,
  createAllowanceFailure,
  deleteAllowanceSuccess,
  deleteAllowanceFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Allowances
function* fetchAllowancesSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_GET_ALLOWANCES, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve allowances!");
    }
    yield put(fetchAllowancesSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchAllowancesFailure(error.message));
  }
}

// Create Allowance Saga
function* createAllowanceSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_CREATE_ALLOWANCE, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Allowance saved successfully!",
      });
      yield put(createAllowanceSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchAllowances(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createAllowanceFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the allowance",
    });
    yield put(createAllowanceFailure(error.message));
  }
}

function* deleteAllowanceSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_DELETE_ALLOWANCE, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Allowance deleted successfully!",
      });
      yield put(deleteAllowanceSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete allowance!",
      });
      yield put(deleteAllowanceFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Allowance Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the allowance",
    });
    yield put(deleteAllowanceFailure(error.message));
  }
}

// Watcher Saga
function* payrollSetupAllowanceSaga() {
  yield takeEvery(FETCH_ALLOWANCES, fetchAllowancesSaga);
  yield takeEvery(CREATE_ALLOWANCE_REQUEST, createAllowanceSaga);
  yield takeEvery(DELETE_ALLOWANCE, deleteAllowanceSaga);
}

export default payrollSetupAllowanceSaga;
